"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getModuleId = getModuleId;
exports.shortenModuleName = shortenModuleName;
exports.lengthenModuleName = lengthenModuleName;
const ids = new Set();
/**
 * If this is enabled it logs the name of the loaded module.  This is helpful when trying to analyze which node
 * modules are getting loaded on the client.
 * @param id
 */
function logModuleId(id) {
    if (process.env.LOG_MODULE_ID === 'true' && typeof window !== undefined && !ids.has(id)) {
        console.log('Loaded:', id);
        ids.add(id);
    }
    return id;
}
/**
 * Get the module id from a module
 * @param module
 */
function getModuleId(module) {
    return logModuleId(typeof module === 'string' ? module : module.id != '.' ? module.id : module.filename);
}
/**
 * Create a short module name
 * @param module
 * @return {*}
 */
function shortenModuleName(module) {
    const moduleId = getModuleId(module);
    const shortModuleId = moduleId
        // remove relative path
        .replace(/^\.+\//, '')
        // remove file extension
        .replace(/\.(\w+)$/, '');
    const parts = shortModuleId.split('/');
    // If the last part is the same as the second to last part, then
    // we remove it. This is assumed to be the case when not using index files
    // and instead using named files in similarly named directories.
    if (parts.length > 2 && parts.at(-2) === parts.at(-1)) {
        parts.pop();
    }
    return (parts
        .join('_')
        // remove any .js file extension left over
        .replace(/\.js$/, '')
        // replace any leftover extension parts with a tilde, so it's not treated as a file path
        .replace(/\./, '~'));
}
/**
 * Turn the module name back into a path
 * @param module
 * @return {*}
 */
function lengthenModuleName(module) {
    const moduleId = getModuleId(module);
    const parts = moduleId.split('_');
    // join with forward slash and hydrate tilde
    return parts.join('/').replaceAll('~', '.');
}
//# sourceMappingURL=ModuleIdHelper.js.map